import { makeQuery } from 'shared/utilities';
import { INewsModel } from 'shared/models';

type ResponseType = {
    item: INewsModel;
};

export const newsGetQuery = async function (id: number) {
    return await makeQuery<ResponseType>('/news/get', { params: {id} });
}
